

import axios from '@u/request';


export default{
    
}

export const stringIsNull=(value)=>{
    return !value || value.length===0;
}

export const numberToFixedLengthString=(num, length)=> {
    return num.toString().padStart(length, '0');
}

//export const reqDefineDatasApi  = async (data) => await axios.get("/user/data_define",data);
export const reqDefineDatasApi  = (data) => axios.get("/user/data_define",data);
/**
 * 禁用用户
 */
export const requestDeleteUserApi = (data) => axios.get('/user/delete',data)
/**
 * 激活用户
 */
export const requestActiveUserApi = (data) => axios.get('/user/active',data)

/**
 * 获取用户列表，可根据关键字查询
 */
export const requestUserInfosApi = (data) =>axios.get('/user/find_limit_page',data)

/**
 * 根据companyId获取详细信息
 */
export const reqCompanyDetailInfos = (data) => axios.get('/company/find_one',data)
/**
 * 根据ids获取公司信息/company/find_more
 */
export const companyInfoWithIdsApi = (data) => axios.get('/company/find_more',data);

/**
 * web端登录请求/user/login
 */
export const webLoginReqApi = (data) => axios.get('/user/login',data);
/**
 * web端登录
 */
export const webDoGetApi = (uri,data) => axios.get(uri,data);
/**
 * 通过gps设备的macId获取关联的车辆/vehicle/vehicle4_macid
 */
//export const vehicle4Macid = (data) => axios.get('/vehicle/vehicle4_macid',data);
/**
 * 微信扫码登录
 * @param {code,platform,state} data 
 * @returns 
 */
export const webLoginWXReqApi = (data) => axios.post('/user/wxlogin',data)
/**
 * 获取用户信息
 * @param {} data 
 * @returns 
 */
export const reqUserInfoApi = (data) => axios.get('/user/userInfo',data);

/**
 * 获取微信扫码信息
 * @param {无} data 
 * @returns 
 */
//export const webLoginWXReqInfoApi = (data) => axios.get('/user/wxlogin_web_info',data)
export const webLoginWXReqInfoApi = (data) => axios.post('/user/wxScan',data)
/**
 * 根据订单id获取订单信息/order/one
 */
export const orderWithIdApi = (data) => axios.get('/order/one',data);

/**
 * 分页获取订单列表/order/list_page
 */
export const ordersForPageListApi = (data) => axios.get('/order/list_page',data);

/**
 * 中止订单/order/auth_break
 */
export const orderBreakApi = (data) => axios.get('/order/auth_break',data);

/**
 * 获取当前用户下的指定日期的所有订单/order/find_with_date
 */
export const activeOrdersApi = (data) => axios.get('/order/find_with_date',data);

/**
 * 根据运单id获取该运单的gps位置数据
 * /gps/pos_data_with_waybill
 * /gps/pos_data_with_waybill2
 */
export const gpsPosDataWithWaybillApi = (data) => axios.get('/gps/pos_data_with_waybill',data);
export const gpsPosDataWithWaybill2Api = (data) => axios.get('/gps/pos_data_with_waybill2',data);

/**
 * 根据所有订单id获取订单的公司信息
 * /company/find_with_orders
 */
export const companyInfosWithOrderIdsApi = (data) => axios.get('/company/find_with_orders',data);

/**
 * 根据司机id获取司机详细信息
 */
export const requestDriverInfosWithDriverId = (data) => axios.get('/driver/driver_info',data)

/**
 * 请求司机通过认证
 */
export const requestDriverAuthPassApi = (data) =>axios.get('/driver/auth_pass',data)

/**
 * 拒绝司机认证
 */
export const requestDriverAuthRefuseApi = (data) => axios.get('/driver/auth_failed',data)

/**
 * 根据指定运单id获取对应的订单信息
 * /order/find_with_waybill
 */
export const orderInfosWithWaybillIdsApi = (data) => axios.get('/order/find_with_waybill',data);

/**
 * 分页获取运单信息
 * /waybill/all_page
 */
export const requestWaybillInfosApi = (data) => axios.get('/waybill/all_page',data);

/**
 * 根据ids获取运单信息
 * /waybill/more
 */
export const requestWaybillInfoWithIdsApi = (data) => axios.get('/waybill/more',data)
/**
 * 运单验收
 * /waybill/verfity
 */
export const reqWaybillVerfityApi = (data) => axios.get('/waybill/verfity',data)
/**
 * 根据用户id获取用户信息
 * /user/find_one
 */
export const requestUserInfoWithUserIdApi = (data) => axios.get('/user/find_one',data)

/**
 * 根据司机id获取司机信息
 * /driver/find_one
 */
export const requestDriverInfoWithDriverIdApi = (data) => axios.get('/driver/find_one',data)

//获取人脸核验信息
export const requestFacialInfoWithDriverIdApi = (data) => axios.get('/driver/facial_info',data)

/**
 * 根据司机Id获取多个司机信息
 */
export const requestDriverInfosWithDriverIdApi = (data) => axios.get('/driver/find_more',data)
/**
 * 根据图片id获取图片信息
 * /file/infos
 */
export const requestImageInfosWithHandlersApi = (data) => axios.get('/file/infos',data)
/**
 * 根据车辆id获取车辆信息
 * /vehicle/find_one
 */
export const requestVehicleInfoWithVehicleIdApi = (data) => axios.get('/vehicle/find_one',data)

/**
 * 获取订单下的所有运单
 * /waybill/req_by_order
 */
export const requestWaybillsWithOrderIdApi = (data) => axios.get('/waybill/req_by_order',data)

/**
 * 获取订单下的所有绑定车辆
 * /vehicle/req_by_order
 */
export const requestVehicleWithOrderIdApi = (data) => axios.get('/vehicle/req_by_order',data)
/**
 * 分页获取车辆信息
 * /vehicle/all_page
 */
export const reqVehicles4PageApi = (data) => axios.get('/vehicle/all_page',data)

/**
 * 分页获取车辆及相关信息
 */
export const reqVehiclesAll4PageApi = (data) => axios.get('/vehicle/all_page_dto',data)

/**
 * 车辆审核通过
 */
export const reqVehicleAuthPassApi = (data) => axios.get('/vehicle/auth_pass',data)

/**
 * 车辆审核拒绝
 */
export const reqVehicleAuthFailApi = (data) => axios.get('/vehicle/auth_failed',data)
/**
 * 禁用或者使能车辆
 * /vehicle/enable
 */
export const vehicleEnabledApi = (data) => axios.get('/vehicle/enable',data)

/**
 * 车辆绑定拥有都
 */
export const vehicleBindOwnerApi = (data) => axios.get('/vehicle/bind_owner',data)

/**
 * 车辆绑定司机
 */
export const vehicleBindDriverApi = (data) => axios.get('/vehicle/bind_driver',data)
/**
 * 请求所有的司机和货主用户
 * /user/user_driver_company
 */
export const requestUserWithDriverOrCompany = (data) => axios.get('/user/user_driver_company',data)

/**
 * 设置gps设备序列号
 * /gps/new
 */
export const requestSetGPSDevice = (data) => axios.get('/gps/new',data)

/**
 * 请求gps设备
 * /gps/devices
 */
export const requestGPSDeviceData =(data) => axios.get('/gps/devices',data)

/**
 * 根据车辆id获取车辆信息
 * /vehicle/find_more
 */
export const requestMoreVehiclesApi = (data) => axios.get('/vehicle/find_more',data)

/**
 * 解除车辆与司机的绑定
 */
export const requestVehicleUnbindDriverApi = (data) => axios.get('/vehicle/unbind_driver',data)

/**
 * 司机审核通过
 */
export const requestCompanyAuthPassApi = (data) => axios.get('/company/auth_pass',data)

/**
 * 解除车辆与车队长绑定
 */
export const requestVehicleUnbindOwnerApi = (data) => axios.get('/vehicle/unbind_owner',data)

/**
 * 解绑gps设备
 * /gps/unbind
 */
//export const requestUnbindGpsDeviceApi = (data) => axios.get('/gps/unbind',data)
export const requestUnbindGpsDeviceApi = (data) => axios.get('/vehicle_device/veh_unbind_dev',data)

/**
 * 绑定gps设备
 * /vehicle/bind_gps_dev
 */
//export const requestBindGpsDeviceApi = (data) => axios.get('/vehicle/bind_gps_dev',data)
export const requestBindGpsDeviceApi = (data) => axios.get('/vehicle_device/veh_bind_dev',data)

/**
 * 获取gps设备数据
 */
//export const requestGpsDevicesApi = (data) => axios.get('/gps/devices',data)
//export const requestGpsDevicesApi = (data) => axios.get('/gps/devices_dto',data)

export const requestGpsDevicesApi = (data) => axios.post("/gps/find_device",data)

export const requestDelGpsDeviceApi = (data) => axios.post("/gps/del_device",data)

export const requestDelGpsDeviceExApi = (data) => axios.post("/gps/find_device_ex",data)
/**
 * 获取未绑定的gps设备数据
 */
export const requestGpsDevicesNoBindApi = (data) => axios.get('/gps/devices_dto_no_bind',data)

/**
 * 获取公司所属订单，用于货主
 */
export const requestOrdersWithCompanyApi = (data) => axios.get('/order/list_page_company',data)

/**
 * 获取订单详细信息，用于货主
 */
export const requestOrderInfoWithCompanyApi = (data) => axios.get('/order/order_info_company',data)

/**
 * 获取运单详细信息，用于货主
 */
export const requestWaybillInfoWithCompanyApi = (data) => axios.get('/waybill/waybill_info_company',data)

/**
 * 获取运单基础信息列表，用于货主
 */
export const requestWaybillBaseWithCompanyApi = (data) => axios.get('/waybill/all_page_company',data)

/**
 * 运单添加至结算状态
 */
export const addWaybillToPayReadyWithCompanyApi = (data) => axios.get('/waybill/setting_pay_ready_company',data)

/**
 * 运单完成结算
 */
export const reqSetWaybillToPayOverWithCompanyApi = (data) => axios.get("/waybill/setting_pay_over_company",data)

/**
 * 运单组完成结算
 */
export const reqSetWaybillGroupPayOverWithCompanyApi = (data) => axios.post("/waybill/group_pay_over_company",data)

/**
 * 通过结算状态获取运单列表，以分组方式
 */
//export const reqWaybillGroupPayReadyWithCompayApi = (data) => axios.get('/waybill/list_group_pay_state_company',data)

/**
 * 通过结算状态获取运单列表，以列表方式
 */
export const reqWaybillPayReadyWithCompayApi = (data) => axios.get('/waybill/list_pay_state_company',data)

/**
 * 通过结算状态获取运单列表，以列表分页方式
 */
export const reqWaybillPayStatePageWithCompayApi = (data) => axios.get('/waybill/page_pay_state_company',data)

/**
 * 通过结算状态获取运单列表，以分组方式
 */
export const reqWaybillGroup4PayStateWithCompanyApi = (data) => axios.post('/waybill/list_group_pay_state_company',data)

/**
 * 根据税务开票状态获取已结算的运单组列表
 */
export const reqWaybillGroup4TaxInvoicingStateWithCompanyApi = (data) => axios.post('/waybill/list_group_pay_state_company_page',data)

/**
 * 根据订单Id、车辆Id、结算状态获取运单基础数据
 */
export const reqWaybillsWithOrderVehiclePayStateApi = (data) => axios.get('/waybill/list_with_ovp_company',data)

/**
 * 根据运单结算分组获取运单数据
 */
export const reqWaybillsWithWaybillGroupApi = (data) => axios.get('/waybill/waybill_with_group',data)

/**
 * 获取所有运费计算规则列表
 */
export const reqCalculationRuleApi = (data) => axios.get('/calc/rules',data)

/**
 * 给货主添加运费计算规则权限
 */
export const addCalculationRuleToCompanyApi = (data) => axios.get('/calc/add_rule_with_com',data)

/**
 * 获取指定公司id的所以运费计算规则
 */
export const reqCalculationRule4CompanyApi = (data) => axios.get('/calc/rules_4_com',data)

/**
 * 为某一公司添加或者禁止运费计算规则
 */
export const enableCalculationRule2CompanyApi = (data) => axios.get('/calc/enable_rule_2_com',data)

/**
 * 修改自己的密码
 */
export const reqModifyPWSelf = (data) => axios.get('/user/mpo_self',data)

/**
 * 图片识别
 */
export const reqIdentifyImage = (data) => axios.get('/file/identify_img',data)

/**
 * 获取车辆结构数据
 */
export const reqVehicleSimpleData = (data) => axios.get('/vehicle/simple',data)

/**
 * 更新车辆信息
 */
export const reqUpdateVehicleData = (data) => axios.post('/vehicle/update_data',data)

/**
 * 上传车辆代开委托协议
 */
export const reqUpdateAgreementDataApi = (data) => axios.post('/vehicle/update_agreement',data)

/**
 * 上传运输合同
 */
export const reqUpdateContractDataApi = (data) => axios.post('/vehicle/update_contract',data)
/**
 * 添加新的车辆类型名
 */
export const reqNewVehicleType = (data) => axios.get('/vehicle/new_vehicle_type',data)

/**
 * 添加新的车辆能源类型
 */
export const reqNewVehiclePowerType = (data) => axios.get('/vehicle/new_vehicle_power_type',data)

/**
 * 更新司机数据
 */
export const reqUpdateUserDataApi = (data) => axios.post('/user/update_user_data',data)

/**
 * 根据车辆id获取车辆绑定银行卡
 */
export const reqDefaultBankWithVehicleApi = (data) => axios.post('/bank/bankWithVehicle',data)
/**
 * 根据车辆id获取车辆绑定所有银行卡
 */
export const reqBanksWithVehicleApi = (data) => axios.post('/bank/banksWithVehicle',data)

/**
 * 设置使用默认银行卡
 */
export const reqBankDefaultSettingApi = (data) => axios.get('/bank/default',data)

/**
 * 禁用默认银行卡
 */
export const reqDisabledBankDefaultSettingApi = (data) => axios.get('/bank/default_disable',data)

/**
 * 删除银行卡
 */
export const reqBankCardDeleteApi = (data) => axios.get('/bank/delete',data)

/**
 * 更新银行卡信息
 */
export const reqUpdateBankCardInfoApi = (data) => axios.post('/bank/update',data)
/**
 * 增加支付凭证
 */
export const reqAddPayTicketInfoApi = (data) => axios.post('/bank/add_pay_ticket',data)

/**
 * 货主添加税务代开信息
 */
export const reqAddTaxInfoApi = (data) => axios.post('/company/add_tax_info',data)

/**
 * 货主删除税务代开信息
 */
export const reqDelTaxInfoApi = (data) => axios.post('/company/del_tax_info',data)

/**
 * 运单组申请开票
 */
export const reqGroup2TaxInvoicingApplyApi = (data) => axios.post('/waybill/tax_invoicing_apply',data)

/**
 * 分页获取所有运单组信息
 * /waybill/all_groups_page
 */
export const reqWaybillGroupAllPageApi = (data) => axios.get('/waybill/all_groups_page', data)

////////////////////////////////////////////////////content//////////////////////////////////////////////////////////////////////
/**
 *  添加content文本
 */
export const reqAddContent = (data) => axios.post('/content/add',data)
/**
 * 查询content文本数据
 */
export const reqQueryContentData = (data) => axios.post('/content/query',data)
/**
 * 根据id获取Content文本数据
 */
export const reqOneContentDataWithId = (data) => axios.post('/content/one_with_id',data)
/**
 * 更新content数据
 */
export const updateOneContentData = (data) => axios.post('/content/update',data)
/**
 * 删除content数据
 */
export const deleteOneContentData = (data) => axios.post('/content/delete',data)

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * 添加通知消息模板
 */
export const reqAddNotifyTicket = (data) => axios.post('/ticket/add_notify',data)
/**
 * 获取所有通知消息
 */
export const reqAllNotifyTickets = (data) => axios.post('/ticket/notify_all',data)
/**
 * 删除一个通知工单
 */
export const reqDelNotifyTicketsOne = (data) => axios.post('/ticket/notify_del_one',data)